export const formatGuideDate = (date) => new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'long',
	timeZone: 'UTC',
	year: 'numeric'
}).format(new Date(`${date}T00:00:00.000Z`));